<main class="max-w-7xl mx-auto px-4 py-8 grid grid-cols-1 lg:grid-cols-12 gap-8 bg-gray-50/50">

    <!-- COLUMNA IZQUIERDA: CONFIRMACIÓN -->
    <section *ngIf="pedidoNumero()" class="lg:col-span-8 flex flex-col gap-6">
        <div
            class="bg-white p-6 sm:p-10 rounded-3xl border border-gray-100 shadow-sm flex flex-col items-center text-center gap-4">
            <span class="w-16 h-16 rounded-full bg-emerald-500 text-white flex items-center justify-center">
                <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7" />
                </svg>
            </span>
            <h2 class="text-2xl font-black text-gray-800">¡Pedido registrado con éxito!</h2>
            <p class="text-sm text-gray-500">Te avisaremos a <span class="font-bold text-gray-700">{{ pedidoEmail()
                    }}</span> cuando verifiquemos tu pago.</p>
            <div
                class="w-full bg-gray-50 border-2 border-dashed border-gray-200 rounded-2xl p-5 flex flex-col items-center gap-1">
                <span class="text-xs font-bold text-gray-400 uppercase tracking-widest">Tu código de rastreo</span>
                <span class="text-4xl font-black text-rose-500 tracking-wider">#{{ pedidoNumero() }}</span>
                <button type="button" (click)="copiarCodigo()"
                    class="mt-2 px-5 py-2 rounded-2xl border border-gray-200 text-xs font-bold text-gray-600 hover:bg-white cursor-pointer">
                    {{ copiado() ? 'Copiado' : 'Copiar código' }}
                </button>
            </div>
            <p class="text-xs text-gray-400">Guarda este código: con tu correo lo necesitarás para rastrear tu pedido.
            </p>
            <div class="w-full flex flex-col sm:flex-row gap-3">
                <button type="button" (click)="irRastrear()"
                    class="flex-1 py-3.5 bg-rose-500 hover:bg-rose-600 text-white font-bold rounded-2xl text-sm cursor-pointer">Rastrear
                    mi pedido</button>
            </div>
            <button type="button" (click)="irTienda()"
                class="text-sm font-bold text-gray-500 hover:text-gray-800 cursor-pointer">Volver a la tienda</button>
            <p *ngIf="submitError()"
                class="text-xs font-semibold text-red-600 bg-red-50 border border-red-200 rounded-2xl p-3 w-full">{{
                submitError() }}</p>
        </div>
    </section>

    <!-- COLUMNA IZQUIERDA: STEPPER DE PROCESO DE COMPRA -->
    <section *ngIf="!pedidoNumero()" class="lg:col-span-8 flex flex-col gap-6">
        <!-- STEPPER HEADER -->
        <header class="flex items-center justify-between bg-white p-4 rounded-3xl border border-gray-100 shadow-sm">
            <div class="flex items-center gap-6 text-sm">
                <button (click)="goToStep(1)" [class.font-bold]="currentStep() === 1"
                    [class.text-rose-600]="currentStep() === 1" [class.text-gray-400]="currentStep() !== 1"
                    class="flex items-center gap-2 cursor-pointer">
                    <span class="w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold"
                        [ngClass]="step1Valid() ? 'bg-emerald-500 text-white' : 'bg-rose-500 text-white'">1</span>
                    <span>Datos</span>
                </button>

                <span class="text-gray-300">/</span>

                <button (click)="goToStep(2)" [disabled]="!step1Valid()" [class.font-bold]="currentStep() === 2"
                    [class.text-rose-600]="currentStep() === 2" [class.text-gray-400]="currentStep() !== 2"
                    class="flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer">
                    <span class="w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold"
                        [ngClass]="step2Valid() ? 'bg-emerald-500 text-white' : 'bg-rose-500 text-white'">2</span>
                    <span>Entrega</span>
                </button>

                <span class="text-gray-300">/</span>

                <button (click)="goToStep(3)" [disabled]="!step1Valid() || !step2Valid()"
                    [class.font-bold]="currentStep() === 3" [class.text-rose-600]="currentStep() === 3"
                    [class.text-gray-400]="currentStep() !== 3"
                    class="flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer">
                    <span class="w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold"
                        [ngClass]="step3Valid() ? 'bg-emerald-500 text-white' : 'bg-rose-500 text-white'">3</span>
                    <span>Pago</span>
                </button>
            </div>

            <span
                class="text-xs font-semibold text-rose-500 bg-rose-50 px-3 py-1.5 rounded-full flex items-center gap-1">
                <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
                Pago seguro
            </span>
            <span *ngIf="cartService.cartItems().length > 0"
                class="text-xs font-semibold text-gray-500 bg-gray-50 border border-gray-200 px-3 py-1.5 rounded-full flex items-center gap-1">
                Reservado por&nbsp;<span class="font-black text-rose-500">{{ cartService.timeRemaining() }}</span>
            </span>
        </header>

        <!-- SECCIÓN DE FORMULARIO -->
        <div class="bg-white p-6 sm:p-8 rounded-3xl border border-gray-100 shadow-sm">

            <!-- ================= PASO 1: DATOS ================= -->
            <div *ngIf="currentStep() === 1" class="flex flex-col gap-6">
                <h2 class="text-lg font-bold text-gray-800 flex items-center gap-2">
                    <span
                        class="w-6 h-6 rounded-full bg-rose-500 text-white text-xs flex items-center justify-center">1</span>
                    Datos Personales
                </h2>

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="text-xs font-semibold text-gray-600 block mb-1">Nombre *</label>
                        <input type="text" [ngModel]="form().firstName"
                            (ngModelChange)="updateField('firstName', $event)"
                            class="w-full bg-gray-50 border border-gray-200 rounded-2xl px-4 py-2.5 text-sm focus:outline-none focus:border-rose-400" />
                    </div>
                    <div>
                        <label class="text-xs font-semibold text-gray-600 block mb-1">Apellidos *</label>
                        <input type="text" [ngModel]="form().lastName" (ngModelChange)="updateField('lastName', $event)"
                            class="w-full bg-gray-50 border border-gray-200 rounded-2xl px-4 py-2.5 text-sm focus:outline-none focus:border-rose-400" />
                    </div>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label class="text-xs font-semibold text-gray-600 block mb-1">Teléfono *</label>
                        <input type="text" [ngModel]="form().phone" (ngModelChange)="updateField('phone', $event)"
                            placeholder="987654321"
                            class="w-full bg-gray-50 border border-gray-200 rounded-2xl px-4 py-2.5 text-sm focus:outline-none focus:border-rose-400" />
                    </div>
                    <div>
                        <label class="text-xs font-semibold text-gray-600 block mb-1">Correo electrónico *</label>
                        <input type="email" [ngModel]="form().email" (ngModelChange)="updateField('email', $event)"
                            placeholder="correo@ejemplo.com"
                            class="w-full bg-gray-50 border border-gray-200 rounded-2xl px-4 py-2.5 text-sm focus:outline-none focus:border-rose-400" />
                    </div>
                </div>

                <hr class="border-gray-100 my-2" />

                <!-- FACTURACIÓN -->
                <div class="flex flex-col gap-3">
                    <span class="text-xs font-bold text-rose-500 uppercase tracking-wider">Facturación</span>
                    <label class="text-xs text-gray-500">Selecciona tu comprobante</label>

                    <div class="grid grid-cols-2 gap-4">
                        <button type="button" (click)="updateField('voucherType', 'boleta')"
                            [class.border-rose-500]="form().voucherType === 'boleta'"
                            [class.bg-rose-50]="form().voucherType === 'boleta'"
                            class="p-4 border-2 rounded-2xl text-left cursor-pointer transition-all">
                            <div class="font-bold text-sm text-gray-800">Boleta</div>
                            <div class="text-[11px] text-gray-500">Para compras personales con DNI</div>
                        </button>

                        <button type="button" (click)="updateField('voucherType', 'factura')"
                            [class.border-rose-500]="form().voucherType === 'factura'"
                            [class.bg-rose-50]="form().voucherType === 'factura'"
                            class="p-4 border-2 rounded-2xl text-left cursor-pointer transition-all">
                            <div class="font-bold text-sm text-gray-800">Factura</div>
                            <div class="text-[11px] text-gray-500">Para empresas con RUC activo</div>
                        </button>
                    </div>

                    <div class="mt-2">
                        <label class="text-xs font-semibold text-gray-600 block mb-1">
                            {{ form().voucherType === 'boleta' ? 'Ingresa tu DNI (8 dígitos) *' : 'Ingresa tu RUC (11
                            dígitos) *' }}
                        </label>
                        <input type="text" [ngModel]="form().docNumber"
                            (ngModelChange)="updateField('docNumber', $event)"
                            [attr.maxlength]="form().voucherType === 'boleta' ? 8 : 11"
                            class="w-full bg-gray-50 border border-gray-200 rounded-2xl px-4 py-2.5 text-sm focus:outline-none focus:border-rose-400" />
                    </div>
                </div>

                <button (click)="nextStep()" [disabled]="!step1Valid()"
                    class="w-full py-3.5 bg-rose-500 hover:bg-rose-600 text-white font-bold rounded-2xl transition-all shadow-md shadow-rose-200 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer mt-4">
                    Continuar a Entrega
                </button>
            </div>

            <!-- ================= PASO 2: ENTREGA ================= -->
            <div *ngIf="currentStep() === 2" class="flex flex-col gap-6">
                <h2 class="text-lg font-bold text-gray-800 flex items-center gap-2">
                    <span
                        class="w-6 h-6 rounded-full bg-rose-500 text-white text-xs flex items-center justify-center">2</span>
                    Entrega y Ubicación
                </h2>

                <!-- TIPO DE ENTREGA -->
                <div class="grid grid-cols-2 gap-4">
                    <button type="button" (click)="updateField('deliveryType', 'delivery')"
                        [class.border-rose-500]="form().deliveryType === 'delivery'"
                        [class.bg-rose-50]="form().deliveryType === 'delivery'"
                        class="p-4 border-2 rounded-2xl flex items-center justify-between cursor-pointer">
                        <div>
                            <div class="font-bold text-sm text-gray-800">Delivery</div>
                            <div class="text-[11px] text-gray-500">Llevamos tu pedido a la dirección elegida</div>
                        </div>
                        <span>
                            <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M3 7h11v8H3zM14 10h4l3 3v2h-7zM7 20a2 2 0 100-4 2 2 0 000 4zm11 0a2 2 0 100-4 2 2 0 000 4z" />
                            </svg>
                        </span>
                    </button>

                    <button type="button" (click)="updateField('deliveryType', 'pickup')"
                        [class.border-rose-500]="form().deliveryType === 'pickup'"
                        [class.bg-rose-50]="form().deliveryType === 'pickup'"
                        class="p-4 border-2 rounded-2xl flex items-center justify-between cursor-pointer">
                        <div>
                            <div class="font-bold text-sm text-gray-800">Retiro en taller</div>
                            <div class="text-[11px] text-gray-500">Recoge en nuestro local gratis</div>
                        </div>
                        <span>
                            <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M3 9l9-6 9 6v11a1 1 0 01-1 1h-5v-7h-6v7H4a1 1 0 01-1-1V9z" />
                            </svg>
                        </span>
                    </button>
                </div>

                <!-- ¿QUIÉN RECIBE? -->
                <div class="flex flex-col gap-3">
                    <span class="text-xs font-bold text-gray-600">¿Quién recibe?</span>
                    <div class="grid grid-cols-2 gap-3">
                        <button type="button" (click)="updateField('recipientType', 'other')"
                            [class.bg-rose-500]="form().recipientType === 'other'"
                            [class.text-white]="form().recipientType === 'other'"
                            [class.bg-gray-100]="form().recipientType !== 'other'"
                            class="py-2.5 rounded-xl text-xs font-bold cursor-pointer">
                            Lo recibe otra persona
                        </button>
                        <button type="button" (click)="updateField('recipientType', 'self')"
                            [class.bg-rose-500]="form().recipientType === 'self'"
                            [class.text-white]="form().recipientType === 'self'"
                            [class.bg-gray-100]="form().recipientType !== 'self'"
                            class="py-2.5 rounded-xl text-xs font-bold cursor-pointer">
                            Lo recibo yo
                        </button>
                    </div>

                    <div *ngIf="form().recipientType === 'other'" class="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-2">
                        <input type="text" [ngModel]="form().recipientName"
                            (ngModelChange)="updateField('recipientName', $event)"
                            placeholder="Nombre de quien recibe *"
                            class="bg-gray-50 border border-gray-200 rounded-2xl px-4 py-2.5 text-sm" />
                        <input type="text" [ngModel]="form().recipientLastName"
                            (ngModelChange)="updateField('recipientLastName', $event)" placeholder="Apellidos *"
                            class="bg-gray-50 border border-gray-200 rounded-2xl px-4 py-2.5 text-sm" />
                        <input type="text" [ngModel]="form().recipientPhone"
                            (ngModelChange)="updateField('recipientPhone', $event)"
                            placeholder="Celular de quien recibe *"
                            class="sm:col-span-2 bg-gray-50 border border-gray-200 rounded-2xl px-4 py-2.5 text-sm" />
                    </div>
                </div>

                <!-- MENSAJE DE DEDICATORIA -->
                <div>
                    <label class="text-xs font-semibold text-gray-600 block mb-1">Mensaje para la tarjeta
                        (opcional)</label>
                    <textarea [ngModel]="form().cardMessage" (ngModelChange)="updateField('cardMessage', $event)"
                        rows="2" placeholder="Escribe aquí la dedicatoria que irá en la tarjeta..."
                        class="w-full bg-gray-50 border border-gray-200 rounded-2xl p-3 text-sm"></textarea>
                </div>

                <!-- MAPA Y DIRECCIÓN (Solo si es Delivery) -->
                <div *ngIf="form().deliveryType === 'delivery'" class="flex flex-col gap-3">
                    <div class="flex items-center justify-between">
                        <label class="text-xs font-bold text-gray-700">Dirección y Distrito *</label>

                        <!-- INTEGRACIÓN COMPONENTE MAP PICKER BUTTON -->
                        <app-map-picker-button #mapPickerBtn mode="search" [value]="form().location"
                            buttonLabel="Ampliar mapa" editLabel="Cambiar en mapa"
                            (selected)="onLocationSelected($event)">
                        </app-map-picker-button>
                    </div>

                    <input readonly type="text" [ngModel]="form().address"
                        (ngModelChange)="updateField('address', $event)" (click)="mapPickerBtn.openPicker()"
                        placeholder="Ej: Av. El Sol 123, Puno"
                        class="w-full bg-gray-50 border border-gray-200 rounded-2xl px-4 py-2.5 text-sm hover:cursor-pointer select-none" />

                    <input type="text" [ngModel]="form().reference" (ngModelChange)="updateField('reference', $event)"
                        placeholder="Referencia (Ej: frente al parque, casa celeste)"
                        class="w-full bg-gray-50 border border-gray-200 rounded-2xl px-4 py-2.5 text-sm" />
                </div>

                <!-- BOTONES NAVEGACIÓN -->
                <div class="flex gap-3 mt-4">
                    <button (click)="prevStep()"
                        class="w-1/3 py-3.5 border border-gray-200 text-gray-600 font-bold rounded-2xl hover:bg-gray-50 cursor-pointer">
                        Volver
                    </button>
                    <button (click)="nextStep()" [disabled]="!step2Valid()"
                        class="w-2/3 py-3.5 bg-rose-500 hover:bg-rose-600 text-white font-bold rounded-2xl shadow-md shadow-rose-200 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer">
                        Continuar a Pago
                    </button>
                </div>
            </div>

            <!-- ================= PASO 3: PAGO (EXCLUSIVO YAPE / PLIN) ================= -->
            <div *ngIf="currentStep() === 3" class="flex flex-col gap-6">
                <h2 class="text-lg font-bold text-gray-800 flex items-center gap-2">
                    <span
                        class="w-6 h-6 rounded-full bg-rose-500 text-white text-xs flex items-center justify-center">3</span>
                    Método de Pago
                </h2>

                <div class="grid grid-cols-2 gap-4">
                    <button type="button" (click)="updateField('paymentMethod', 'yape')"
                        [class.border-rose-500]="form().paymentMethod === 'yape'"
                        [class.bg-purple-50]="form().paymentMethod === 'yape'"
                        class="p-4 border-2 rounded-2xl flex items-center justify-between cursor-pointer">
                        <span class="font-bold text-purple-700">Yape</span>
                        <span class="text-xs bg-purple-100 text-purple-700 px-2 py-0.5 rounded-full font-bold">QR</span>
                    </button>

                    <button type="button" (click)="updateField('paymentMethod', 'plin')"
                        [class.border-rose-500]="form().paymentMethod === 'plin'"
                        [class.bg-sky-50]="form().paymentMethod === 'plin'"
                        class="p-4 border-2 rounded-2xl flex items-center justify-between cursor-pointer">
                        <span class="font-bold text-sky-600">Plin</span>
                        <span class="text-xs bg-sky-100 text-sky-700 px-2 py-0.5 rounded-full font-bold">QR</span>
                    </button>
                </div>

                <!-- ADJUNTO DE COMPROBANTE -->
                <div *ngIf="form().paymentMethod"
                    class="flex flex-col gap-3 p-4 bg-gray-50 rounded-2xl border border-gray-200">
                    <span class="text-xs font-bold text-gray-700">Adjuntar voucher de transferencia *</span>
                    <p class="text-xs text-gray-500" *ngIf="metodoSeleccionado() as m">
                        Realiza el pago por {{ form().paymentMethod | uppercase }} al número {{ m.numero }} ({{
                        m.titular }}) y adjunta la captura de pantalla.
                        <span *ngIf="m.instrucciones">{{ m.instrucciones }}</span>
                    </p>

                    <label
                        class="flex flex-col items-center justify-center p-4 border-2 border-dashed border-gray-300 rounded-2xl bg-white hover:bg-gray-50 cursor-pointer transition-colors">
                        <span class="text-xs font-bold text-rose-500 flex items-center gap-2">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M12 4v12m0 0l-4-4m4 4l4-4" />
                            </svg>
                            {{ form().voucherFileName ? form().voucherFileName : 'Seleccionar comprobante (JPG, PNG)' }}
                        </span>
                        <input type="file" (change)="onFileSelected($event)" accept="image/*" class="hidden" />
                    </label>
                </div>

                <!-- TÉRMINOS Y CONDICIONES -->
                <label class="flex items-start gap-2 text-xs text-gray-600 cursor-pointer mt-2">
                    <input type="checkbox" [ngModel]="form().termsAccepted"
                        (ngModelChange)="updateField('termsAccepted', $event)" class="mt-0.5 rounded accent-rose-500" />
                    <span>He leído y estoy de acuerdo con los términos y condiciones de la web. *</span>
                </label>

                <!-- BOTONES DE ACCIÓN -->
                <div *ngIf="submitError() && !pedidoNumero()"
                    class="p-3 bg-red-50 border border-red-200 rounded-2xl text-xs font-semibold text-red-600">
                    {{ submitError() }}
                </div>
                <div *ngIf="!pedidoUuid()" class="flex gap-3 mt-4">
                    <button (click)="prevStep()"
                        class="w-1/3 py-3.5 border border-gray-200 text-gray-600 font-bold rounded-2xl hover:bg-gray-50 cursor-pointer">
                        Volver
                    </button>
                    <button (click)="submitFinalOrder()" [disabled]="!step3Valid() || submitting()"
                        class="w-2/3 py-3.5 bg-rose-500 hover:bg-rose-600 text-white font-bold rounded-2xl shadow-md shadow-rose-200 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer uppercase text-sm">
                        {{ submitting() ? 'Procesando...' : 'Pagar S/ ' + orderTotal().toFixed(2) }}
                    </button>
                </div>
            </div>

        </div>
    </section>

    <!-- COLUMNA DERECHA: RESUMEN DEL PEDIDO -->
    <aside *ngIf="!pedidoNumero()" class="lg:col-span-4 flex flex-col gap-4">
        <div class="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm sticky top-6">
            <h3 class="font-bold text-gray-800 text-base mb-4">Resumen del pedido</h3>

            <!-- PRODUCTOS -->
            <div class="flex flex-col gap-3 mb-4">
                <div *ngIf="cartService.cartItems().length === 0" class="text-xs text-gray-400">
                    Tu carrito está vacío.
                </div>
                <div *ngFor="let item of cartService.cartItems()" class="flex items-center gap-3">
                    <img [src]="item.image" [alt]="item.title" class="w-12 h-12 object-cover rounded-xl" />
                    <div class="flex-1">
                        <h4 class="text-xs font-bold text-gray-700">{{ item.title }} × {{ item.quantity }}</h4>
                        <div class="text-xs font-extrabold text-rose-500">S/ {{ (item.price * item.quantity).toFixed(2)
                            }}</div>
                    </div>
                </div>
            </div>

            <hr class="border-gray-100 my-3" />

            <!-- COSTOS -->
            <div class="flex flex-col gap-2 text-xs">
                <div class="flex justify-between text-gray-600">
                    <span>Subtotal</span>
                    <span class="font-bold">S/ {{ cartSubtotal().toFixed(2) }}</span>
                </div>
                <div class="flex justify-between text-gray-600">
                    <span>Envío</span>
                    <span class="font-bold text-rose-500">
                        {{ form().deliveryType === 'delivery' ? 'S/ ' + costoEnvio().toFixed(2) : 'Gratis' }}
                    </span>
                </div>
            </div>

            <hr class="border-gray-100 my-3" />

            <div class="flex justify-between items-baseline">
                <span class="font-bold text-gray-800 text-base">Total</span>
                <span class="font-black text-rose-500 text-xl">S/ {{ orderTotal().toFixed(2) }}</span>
            </div>
        </div>
    </aside>

</main>